import { render } from "./search-suppliers.vue?vue&type=template&id=174b7710"
import script from "./search-suppliers.vue?vue&type=script&lang=js"
export * from "./search-suppliers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__